export default {
  account: '帳號',
  accountPlaceholder: '請輸入帳號',
  operationTime: '操作時間',
  startTime: '開始時間',
  endTime: '結束時間',
  search: '搜索',
  name: '姓名',
  ip: 'IP',
  applicationModule: '應用模塊',
  operationContent: '操作內容',
  antiFake: '防偽溯源',
  marketing: '營銷活動',
};
